import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "4:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-1-mode.png`,
        },
      },
    },
  },
  "4:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-2-modes.png`,
        },
      },
    },
  },
  "4:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-3-modes.png`,
        },
      },
    },
  },
  "4:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-4-modes.png`,
        },
      },
    },
  },
};

export default components;
